<template>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
            <div class="row filter-row">
                <div class="col-sm-6 col-md-4 col-lg-4 col-xl-3 col-12 employee-name" style="margin-right: auto">
                    <h4>Report ({{ userName }})</h4>
                </div>
                <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
                    <div class="input-block mb-3 form-focus">
                         <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
          style="z-index: 100; font-size: 12px;">From</label>
                        <div class="cal-icon">
                            <date-picker v-model="startDate" class="form-control floating datetimepicker"
                                :editable="true" :clearable="false" :inputFormat="dateFormat" @update:model-value="onSearchClick" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
                    <div class="input-block mb-3 form-focus">
                        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
          style="z-index: 100; font-size: 12px;">To</label>
                        <div class="cal-icon">
                            <date-picker v-model="endDate" placeholder="To" class="form-control floating datetimepicker"
                                :editable="true" :clearable="false" :inputFormat="dateFormat" @update:model-value="onSearchClick" />
                        </div>
                    </div>
                </div>
                <v-divider opacity="0.5"></v-divider>
            </div>
            <div>
               <v-col cols="12" class="pb-0 d-flex justify-content-end">
                            
                                   

                                    <div>
                                        <div class="btn btn-outline-success ms-3" @click="downloadUserReport()">
                                            <span v-if="!singleDownloadLoad">Download Simple Report</span>
                                            <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                                                <div class="spinner-border spinner-border-sm" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="btn btn-outline-success ms-3" @click="downloadFullReport()">
                                            <span v-if="!fullDownloadLoad">Download Full Report</span>
                                            <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                                                <div class="spinner-border spinner-border-sm" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                

                            </v-col>
                            </div>
            <h4 class="pb-3">Summary</h4>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Type
                                    </th>
                                    <th class="text-left">
                                        24H
                                    </th>
                                    <th class="text-left">
                                        Schedule
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Time on site including break taken</td>
                                    <td>{{ timeOnSite }}</td>
                                    <td>{{ totalTimeOnSiteIncludingBreakSchedule }}</td>
                                </tr>
                                <tr>
                                    <td>Break taken</td>
                                    <td>{{ totalBreakTime }}</td>
                                    <td>{{ totalBreakTime }}</td>
                                </tr>
                                <tr>
                                    <td>Allowed paid break</td>
                                    <td>{{ allowedBreak }}<span v-if="totalExtraBreak > 0"> (+{{ totalExtraBreak }} mins)</span></td>
                                    <td>{{ totalScheduledBreak }}</td>
                                </tr>
                                <!-- <tr>
                                            <td>Allowed unpaid break</td>
                                            <td>0</td>
                                        </tr> -->
                                
                                <tr>
                                    <td>Time on site after break deduction</td>
                                    <td>{{ totalTimeOnSiteAfterBreakDeduction }}</td>
                                    <td>{{ totalTimeOnSiteAfterBreakSchedule }}</td>
                                </tr>
                                <tr>
                                    <td>Expected time on site</td>
                                    <td>{{ totalExpectedTimeOnSite }}</td>
                                    <td>{{ totalExpectedTimeOnSite }}</td>
                                </tr>
                                <tr>
                                    <td>Additional shift time / Banked time</td>
                                    <td>{{ bankedTime }}</td>
                                    <td>{{ bankedTime }}</td>
                                </tr>
                                <tr>
                                    <td>Leave days (Hours worked)</td>
                                    <td>{{ paidLeaves }} ({{ leaveDayWorkingHours }})</td>
                                    <td>{{ paidLeaves }} ({{ leaveDayWorkingHours }})</td>
                                </tr>
                                

                            </tbody>
                        </template>
                    </v-table>
                </v-col>

                <v-col cols="12" sm="6">
                    <v-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Type
                                    </th>
                                    <th class="text-left">
                                        Value
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Working days</td>
                                    <td>{{ workingDays }}</td>
                                </tr>
                                <tr>
                                    <td>Actual days present</td>
                                    <td>{{ presentDays }}</td>
                                </tr>
                                <tr>
                                    <td>Non working days</td>
                                    <td>{{ nonWorkingDays }}</td>
                                </tr>
                                <!-- <tr>
                                            <td>Paid leaves</td>
                                            <td>{{ paidLeaves }}</td>
                                        </tr>
                                        <tr>
                                            <td>Unpaid leaves</td>
                                            <td>{{ unPaidLeaves }}</td>
                                        </tr> -->
                                <tr>
                                    <td>Absent</td>
                                    <td>{{ absent }}</td>
                                </tr>
                                <!-- <tr>
                                    <td>Leave days (Hours worked)</td>
                                    <td>{{ paidLeaves }} ({{ leaveDayWorkingHours }})</td>
                                </tr> -->
                                <tr>
                                    <td>Unpaid leaves</td>
                                    <td>{{ unPaidLeaves }}</td>
                                </tr>
                                <tr>
                                    <td>Sick leave</td>
                                    <td>{{ totalSickLeaveDays }}</td>
                                </tr>
                               <tr>
                                    <td>Unscheduled work days</td>
                                    <td>{{ unscheduledWorkDays }}</td>
                                </tr>
                                <tr>
                                    <td>Manually edited days</td>
                                    <td>{{ manuallyEditedDays }}</td>
                                </tr>
                                
                            </tbody>
                        </template>
                    </v-table>
                </v-col>
            </v-row>
            <v-divider opacity="0.5"></v-divider>
            <div v-for="r of report" :key="r.userId" class="report">

                <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center flex-wrap">
                        <h3 class="my-2 me-3">
                            {{ dateToMonthName(r['schedule']['date']) }}
                        </h3>
                        <v-chip v-if="r['isUserOnLeave']" class="ma-1" color="primary" text-color="white" size="small">
                            On Leave {{ r['leaveApplication']?.['leave_hour'] ? `(${r['leaveApplication']['leave_hour'].slice(0, 5)})` : '' }}
                        </v-chip>
                        <v-chip v-else-if="!r['isPresent'] && r['schedule']?.['is_working'] && r['schedule']['user_schedule_shifts'].length > 0" class="ma-1"
                            color="red" text-color="white" size="small">Absent
                        </v-chip>
                        <v-chip v-if="(!r['schedule']?.['is_working'] || r['schedule']['user_schedule_shifts'].length == 0) && !r['isUnscheduledWork'] && !r['isUserOnLeave']" class="ma-1" color="primary"
                            text-color="white" size="small">NWD
                        </v-chip>
                        <v-chip v-if="r['isUnscheduledWork']" class="ma-1" color="warning"
                            text-color="white" size="small">Unscheduled
                        </v-chip>
                        <v-chip v-if="r['isManuallyEdited']" class="ma-1" color="amber-darken-3"
                            text-color="white" size="small">Edited
                        </v-chip>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                        <div class="btn btn-outline-info" @click="getUserReport">
                        <i class="fa-solid fa-arrows-rotate me-1" v-if="!loading"></i>
                        <span class="spinner-border spinner-border-sm me-1" role="status" v-else></span>
                        Refresh
                    </div>
                    <span class="icon-circle-2 text-nowrap" style="cursor: pointer;" @click="openAddActivityModal(r)">
                        <i class="fa fa-plus me-1"></i> Add Activity
                    </span>
                    </div>
                </div>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            Type
                                        </th>
                                        <th class="text-left">
                                            Value
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Schedule</td>
                                        <td>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span>{{ r['schedule']['user_schedule_shifts'].length > 0 ?
                                                    timeFormat(r['schedule']['user_schedule_shifts'][0]['from_time']) : '00:00'
                                                }} - {{ r['schedule']['user_schedule_shifts'].length > 0 ?
                                                        timeFormat(r['schedule']['user_schedule_shifts'].slice(-1)[0]['to_time']) :
                                                        '00:00' }}</span>
                                                <span href="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_schedule" @click="editScheduleClicked(r['schedule'])" class="icon-circle">
                                                    <i class="fa-solid fa-pen" v-if="userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN'"></i>
                                                </span>
                                            </div>
                                            <div v-if="r['schedule']?.['updated_by'] || r['schedule']?.['updated_by_user']" class="text-muted mt-1" style="font-size: 0.75rem;">
                                                <i class="fa-solid fa-pen-to-square me-1 text-warning"></i>
                                                Updated 
                                                <span v-if="r['schedule']?.['updated_by_user']">
                                                    by <strong>{{ r['schedule']['updated_by_user']['first_name'] }} {{ r['schedule']['updated_by_user']['last_name'] }}</strong>
                                                </span>
                                                <span v-else-if="r['schedule']?.['updated_by']">
                                                    by <strong>User #{{ r['schedule']['updated_by'] }}</strong>
                                                </span>
                                                <span v-if="r['schedule']?.['updated_at']">
                                                    at <strong>{{ formatDateTimeStandardWithTime(r['schedule']['updated_at']) }}</strong>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>First entry & last exit</td>
                                        <td>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span>{{ timeFormat(r['firstCheckIn']) }} - {{ timeFormat(r['lastCheckOut']) }}</span>
                                                <span v-if="r['schedule']['user_attendance']" href="javascript:;" data-bs-toggle="modal"
                                                    data-bs-target="#edit_attendance" @click="editAttendanceClicked(r['schedule']['user_attendance'])" class="icon-circle">
                                                    <i class="fa-solid fa-pen" v-if="userInfo.account_type == 'SITE MANAGER' || userInfo.account_type == 'ADMIN'"></i>
                                                </span>
                                            </div>
                                            <div v-if="r['schedule']?.['user_attendance']?.['is_manually_edited']" class="text-muted mt-1" style="font-size: 0.75rem;">
                                                <i class="fa-solid fa-pen-to-square me-1 text-warning"></i>
                                                Updated 
                                                <span v-if="r['schedule']['user_attendance']['updated_by_user']">
                                                    by <strong>{{ r['schedule']['user_attendance']['updated_by_user']['first_name'] }} {{ r['schedule']['user_attendance']['updated_by_user']['last_name'] }}</strong>
                                                </span>
                                                <span v-else-if="r['schedule']['user_attendance']['updated_by']">
                                                    by <strong>{{ r['schedule']['user_attendance']['updated_by'] }}</strong>
                                                </span>
                                                <span v-if="r['schedule']['user_attendance']['updated_at']">
                                                    at <strong>{{ formatDateTimeStandardWithTime(r['schedule']['user_attendance']['updated_at']) }}</strong>
                                                </span>
                                                <span v-if="r['schedule']['user_attendance']['reason']">
                                                    &bull; <em>{{ r['schedule']['user_attendance']['reason'] }}</em>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Expected time on site</td>
                                        <td>{{ toTimeString(r['expectedTimeOnSite']) }}</td>
                                    </tr>
                                    <tr>
                                        <td>Additional shift time / Banked time</td>
                                        <td>{{ toTimeString(r['bankedTime']) }}</td>
                                    </tr>
                                    <tr v-if="r['isUserOnLeave'] && r['leaveApplication']?.['leave_hour']">
                                        <td>Leave hours</td>
                                        <td>{{ r['leaveApplication']['leave_hour'].slice(0, 5) }}</td>
                                    </tr>
                                    <!-- <tr>
                                            <td>Remarks</td>
                                            <td></td>
                                        </tr> -->
                                </tbody>
                            </template>
                        </v-table>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <v-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            Type
                                        </th>
                                        <th class="text-left">
                                            24H
                                        </th>
                                        <th class="text-left">
                                            Schedule
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Time on site including break taken</td>
                                        <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['timeOnSiteIncludingBreakInMin']) }}</td>
                                        <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['timeOnSiteWithinScheduleInMin']) }}</td>
                                    </tr>
                                    <tr>
                                        <td>Break taken</td>
                                        <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['breakTimeInMin']) }}</td>
                                        <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['breakTimeInMin']) }}</td>
                                    </tr>
                                    <tr>
                                        <td>Allowed paid break</td>
                                        <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['allowedBreak']) }}<span v-if="r['isPresent'] && (r['breakTimeInMin'] > r['allowedBreak'])"> (+{{ Math.round(r['breakTimeInMin'] - r['allowedBreak']) }} mins)</span></td>
                                        <td>{{ !r['isPresent'] ? '00:00' : toTimeString(r['scheduledDeduction']) }}</td>
                                    </tr>
                                    <tr>
                                        <td>Time on site after break deduction</td>
                                        <td>{{ !r['isPresent'] ? '00:00' : toTimeString(Math.max(0, r['timeOnSiteIncludingBreakInMin'] - Math.max(r['breakTimeInMin'], r['allowedBreak']))) }}
                                        </td>
                                        <td>{{ !r['isPresent'] ? '00:00' : toTimeString(Math.max(0, r['timeOnSiteWithinScheduleInMin'] - Math.max(r['breakTimeInMin'], r['allowedBreak']))) }}
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                            <td>Allowed unpaid break</td>
                                            <td>0</td>
                                        </tr> -->
                                   
                                </tbody>
                            </template>
                        </v-table>
                    </v-col>
                    <v-col cols="12" sm="6" v-if="r.activities.length">
                         <div class="pb-3">
                            <h6 class="pb-3 mb-0">Activities(24 hours)</h6>
                        </div>


                        <v-table>
                            <template v-slot:default>
                       
                        <thead>
                            <tr>
                                <th class="text-left">
                                    Time
                                </th>
                                <th class="text-left">
                                    Type
                                </th>
                                <th class="text-left">
                                    Location
                                </th>
                                <th class="text-left">
                                    Edited
                                </th>
                                <th class="text-left">
                                    Reason
                                </th>
                                <th class="text-left">
                                    Updated By
                                </th>
                                <th class="text-left">
                                    Updated At
                                </th>
                                 <th class="text-left">
                                    Activity Time
                                </th>
                                <th class="text-left">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(a, idx) in r.activities" :key="a.id">

                                <td>{{ formatTo12Hour(a.created_at) }}</td>
                                <td>{{ getActivityTypeLabel(a.type) }}</td>
                                <td>{{ getLocationName(a.location_id) }}</td>
                                <td>{{ a.is_manually_edited ? 'Yes' : 'No' }}</td>
                                <td>{{ a.reason ? a.reason : '--' }}</td>
                                <td>{{ a.updated_by_user ? (a.updated_by_user.first_name + ' ' + a.updated_by_user.last_name) : (a.updated_by && a.updated_by.first_name ? (a.updated_by.first_name + ' ' + a.updated_by.last_name) : (a.updated_by ? a.updated_by : '--')) }}</td>
                                <td>{{ a.is_manually_edited && a.updated_at ? formatDateTimeStandardWithTime(a.updated_at) : '--' }}</td>
                                 <td v-if="r.activities[idx + 1]">
                                    {{ getDiffMinutes(a.created_at, r.activities[idx + 1].created_at) }}
                                </td>
                                <td v-else>--</td>
                                <td>
                                    <div class="d-flex gap-2">
                                        <span class="icon-circle" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#edit_activity" @click="editActivityClicked(a)">
                                            <i class="fa-solid fa-pen"></i>
                                        </span>
                                        <span class="icon-circle" style="cursor: pointer;" @click="deleteActivityClicked(a)">
                                            <i class="fa-solid fa-trash-can"></i>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        </template>
                        </v-table>

                    </v-col>
                   
                    <v-divider opacity="0.5"></v-divider>
                </v-row>
            </div>
        </div>
    </div>
    <edit-attendance-modal ref="editAttendance"></edit-attendance-modal>
    <edit-schedule-modal ref="editSchedule" @editedShift="getUserReport"></edit-schedule-modal>

    <edit-activity-modal ref="editActivity" @activityUpdated="getUserReport"></edit-activity-modal>
    <add-manual-activity-modal ref="addManualActivity" @activityAdded="getUserReport"></add-manual-activity-modal>

    <!-- <edit-schedule-modal ref="editSchedule" @editedShift="getUserData" v-if="showEditModel"></edit-schedule-modal> -->

    <!-- Delete Activity Confirmation Modal -->
    <div class="modal fade" id="delete_activity_modal" tabindex="-1" aria-labelledby="deleteActivityLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteActivityLabel">Delete Activity</h5>
            <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete this activity?</p>
            <div v-if="activityToDelete">
              <p class="mb-1"><strong>Type:</strong> {{ getActivityTypeLabel(activityToDelete.type) }}</p>
              <p class="mb-0"><strong>Time:</strong> {{ activityToDelete.created_at }}</p>
            </div>
            <p class="text-danger mb-0"><small>This action cannot be undone. If deleted in the wrong order, the report will contain errors.</small></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-outline-danger" @click="onDeleteConfirmed" :disabled="isDeleting">
              <span v-if="!isDeleting">Delete</span>
              <div v-else class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';
import { Modal } from 'bootstrap';
import { dateRangeStart, dateRangeEnd } from '@/utils/util-var';
import { VUE_APP_API_BASE_URL } from "../../../config";
import { formatDDMMYYYY, formatMMNameYYYY, formatDayDateMonthYear, minToTimeString, timeFormat, formatTo12Hour, getActivityTypeLabel, formatDateForApi, formatDateTimeStandardWithTime } from '@/utils/util-funcitons';
import EditAttendanceModal from "@/components/modal/edit-user-attendance-modal.vue";
import EditScheduleModal from "@/components/modal/edit-schedule-modal.vue";
import EditActivityModal from "@/components/modal/edit-activity-modal.vue";
import AddManualActivityModal from "@/components/modal/add-manual-activity-modal.vue";

export default {
    components: {
        EditAttendanceModal,
        EditScheduleModal,
        EditActivityModal,
        AddManualActivityModal,
    },
    data() {

        return {
            startDate: dateRangeStart,
            endDate: dateRangeEnd,
            dateFormat: 'dd/MM/yyyy',
            userName: '',
            allowedBreak: '00:00',
            totalExtraBreak: 0,
            totalExpectedTimeOnSite: '00:00',
            totalTimeOnSiteAfterBreakDeduction: '00:00',
            totalTimeOnSiteAfterBreakSchedule: '00:00',
            totalTimeOnSiteIncludingBreakSchedule: '00:00',
            timeOnSite: '00:00',
            totalBreakTime: '00:00',
            paidLeaves: 0,
            unPaidLeaves: 0,
            workingDays: 0,
            nonWorkingDays: 0,
            presentDays: 0,
            absent: 0,
            unscheduledWorkDays: 0,
            manuallyEditedDays: 0,
            bankedTime: '00:00',
            leaveDayWorkingHours: '00:00',
             singleDownloadLoad: false,
            fullDownloadLoad: false,
            report: [],
            locationIdOptions:[],
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            firstCheckInTime:null,
            activityToDelete: null,
            isDeleting: false,
            totalScheduledBreak: '00:00'
        }
    },
    methods: {
        getActivityTypeLabel,
        timeFormat,
        formatTo12Hour,
        formatDateTimeStandardWithTime,
            getLocationName(id) {
      const location = this.locationIdOptions.find(item => item.id === id);
      return location ? location.text : '-';
    },
        toTimeString(minutes) {
            return minToTimeString(minutes);
        },
        dateToMonthName(date) {
            return formatDayDateMonthYear(date);
        },
       getDiffMinutes(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffMs = endDate - startDate;
  const totalMinutes = Math.floor(diffMs / 60000);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Pad with 0 if less than 10
  const paddedHours = hours.toString().padStart(2, '0');
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${paddedHours}hr : ${paddedMinutes}min`;
},
        onSearchClick() {
            this.getUserReport();
        },

        getHourAndMinuteFromString(timeString) {
            // Return fallback if the input is null, undefined, or not a string
            if (!timeString || typeof timeString !== 'string') return '00:00';

            const parts = timeString.split(':');

            // Return fallback if the time string doesn't contain at least hours and minutes
            if (parts.length < 2) return '--';

            const [hours, minutes] = parts;
            return `${hours}:${minutes}`;
        },
        getUserReport() {
           
            const params = {
                start_date: formatDateForApi(this.startDate),
                end_date: formatDateForApi(this.endDate)
            }
            axios.get(`${VUE_APP_API_BASE_URL}/user/${this.$route.params.id}/report`, { params: params })
                .then((response) => {
                    // for(let r of response.data.report){
                    //     console.log(r['schedule']['user_schedule_shifts'].slice(-1)[0]['to_time']);
                    //     break;
                    // }
                    if (response.data.status && response.data.data) {
                        this.userName = response.data.data.userName;
                        this.allowedBreak = minToTimeString(response.data.data.allowedBreak);
                        this.totalExtraBreak = response.data.data.totalExtraBreak || 0;
                        this.totalExpectedTimeOnSite = minToTimeString(response.data.data.expectedTimeOnSite);
                        this.totalTimeOnSiteAfterBreakDeduction = minToTimeString(response.data.data.totalTimeOnSiteAfterBreak);
                        this.totalTimeOnSiteAfterBreakSchedule = minToTimeString(response.data.data.totalTimeOnSiteAfterBreakSchedule);
                        this.totalTimeOnSiteIncludingBreakSchedule = minToTimeString(response.data.data.totalTimeOnSiteIncludingBreakSchedule);
                        this.timeOnSite = minToTimeString(response.data.data.timeOnSite);
                        this.totalBreakTime = minToTimeString(response.data.data.totalBreakTime);
                        this.paidLeaves = response.data.data.paidLeaves;
                        this.unPaidLeaves = response.data.data.unPaidLeaves;
                        this.totalSickLeaveDays = response.data.data.totalSickLeaveDays
                        this.workingDays = response.data.data.workingDays;
                        this.nonWorkingDays = response.data.data.nonWorkingDays;
                        this.presentDays = response.data.data.presentDays;
                        this.absent = response.data.data.absent;
                        this.unscheduledWorkDays = response.data.data.unscheduledWorkDays ?? 0;
                          this.manuallyEditedDays = response.data.data.manuallyEditedDays ?? 0;
                        this.report = response.data.data.report || [];
                        this.bankedTime = minToTimeString(response.data.data.totalBankedTime);
                        this.leaveDayWorkingHours = minToTimeString((response.data.data.leaveDayWorkingHours ?? 0) * 60);

                        // Calculate total scheduled break
                        let totalScheduledBreakMin = 0;
                        this.report.forEach(r => {
                            if (r.isPresent) {
                                totalScheduledBreakMin += (r.scheduledDeduction || 0);
                            }
                        });
                        this.totalScheduledBreak = minToTimeString(totalScheduledBreakMin);
                    } else {
                        const errMsg = response.data?.message ?? (response.data?.data?.message ?? 'Failed to get report');
                        this.$toast.error(errMsg);
                    }
                })
                .finally(() => {
                    // this.loader = false;
                });
        },
          downloadUserReport() {
            this.singleDownloadLoad = true;
            const contractorDetails = {
                start_date: formatDateForApi(this.startDate),
                end_date: formatDateForApi(this.endDate)
            };
            axios.post(`${VUE_APP_API_BASE_URL}/user/${this.$route.params.id}/report/download`, contractorDetails, {
                responseType: 'blob'
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.userName.toUpperCase().replace(/ /g, '_')}_employee_report.pdf`);
                document.body.appendChild(link);
                link.click();
            })
                .catch(error => {
                    this.$toast.error(error.data.errors || 'Download failed');
                    console.error('Download failed:', error);
                })
                .finally(() => {
                    this.singleDownloadLoad = false;
                });
        },

         downloadFullReport() {
            this.fullDownloadLoad = true;
            const contractorDetails = {
                start_date: formatDateForApi(this.startDate),
                end_date: formatDateForApi(this.endDate)
            };
            axios.post(`${VUE_APP_API_BASE_URL}/user/${this.$route.params.id}/full-report/download`, contractorDetails, {
                responseType: 'blob'
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.userName.toUpperCase().replace(/ /g, '_')}_employee_report.pdf`);
                document.body.appendChild(link);
                link.click();
            })
                .catch(error => {
                    this.$toast.error(error.data.errors || 'Download failed');
                    console.error('Download failed:', error);
                })
                .finally(() => {
                    this.fullDownloadLoad = false;
                });
        },
         async getLocationIds() {
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            this.locationIdOptions = response.data.data
            this.locationIdOptions.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              delete element['latitude'];
              delete element['longitude'];
              element['text'] = element['name'];
              delete element['name'];
            }
            )
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {

        });
    },
    editScheduleClicked(record) {
      this.$refs.editSchedule.updateValues(record);
    },
    editAttendanceClicked(record) {
      this.$refs.editAttendance.updateValues(record);
    },
    editActivityClicked(record) {
      this.$refs.editActivity.updateValues(record);
    },
    deleteActivityClicked(activity) {
      this.activityToDelete = activity;
      const modal = new Modal(document.getElementById('delete_activity_modal'));
      modal.show();
    },
    async onDeleteConfirmed() {
      if (!this.activityToDelete) return;
      await this.deleteActivity(this.activityToDelete.id);
      const modalEl = document.getElementById('delete_activity_modal');
      const modal = Modal.getInstance(modalEl);
      if (modal) modal.hide();
      this.activityToDelete = null;
    },
    async deleteActivity(activityId) {
      this.isDeleting = true;
      try {
        const response = await axios.post(`${VUE_APP_API_BASE_URL}/activity/delete`, {
          id: activityId
        });
        if (response.data.status) {
          this.$toast.success('Activity deleted successfully');
          this.getUserReport();
        } else {
          this.$toast.error(response.data.message || response.data.errors);
        }
      } catch (error) {
        if (error.response?.status === 403) {
          this.$toast.error('Only admin can delete activities');
        } else {
          this.$toast.error('Failed to delete activity');
        }
      } finally {
        this.isDeleting = false;
      }
    },

    openAddActivityModal(reportItem) {
        const modal = new Modal(document.getElementById('add_manual_activity'));
        modal.show();

        const modalComponent = this.$refs.addManualActivity;
        if (!modalComponent) return;

        let locationId = null;
        if (reportItem['schedule']['user_schedule_shifts'] && reportItem['schedule']['user_schedule_shifts'].length > 0) {
            locationId = reportItem['schedule']['user_schedule_shifts'][0].location_id;
        } else if (reportItem.activities && reportItem.activities.length > 0) {
            locationId = reportItem.activities[0].location_id;
        }

        modalComponent.prefillValues({
            employeeId: this.$route.params.id,

            date: reportItem['schedule']['date'] || null,
            time: '00:00:00',
            locationId
        });
    }



    },
    mounted() {
        if (this.$route.query.startDate) {
                this.startDate = new Date(this.$route.query.startDate)
                this.endDate = new Date(this.$route.query.endDate)
            }
        this.getUserReport();
        this.getLocationIds();
    }
}
</script>



<style scoped>
/* Add premium box shadow to sub-modals */
:deep(.modal-content) {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25), 0 5px 15px rgba(0, 0, 0, 0.15) !important;
    border: none !important;
}

.icon-circle {
    display: flex;
    background-color: #f7f7f7;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    width: 30px;
    aspect-ratio: 1;
}

.icon-circle-2 {
    display: flex;
    background-color: #f7f7f7;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    width: auto;
    padding: 5px 10px;

}

.filter-row {
    justify-content: flex-end;
}

.employee-name {
    margin-right: auto;
    display: flex;
    align-items: center;
}

.report:last-child hr {
    --v-border-opacity: 0 !important;
}
</style>